import { render, staticRenderFns } from "./my-textarea.vue?vue&type=template&id=f5228506&scoped=true&"
import script from "./my-textarea.vue?vue&type=script&lang=js&"
export * from "./my-textarea.vue?vue&type=script&lang=js&"
import style0 from "./my-textarea.vue?vue&type=style&index=0&id=f5228506&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5228506",
  null
  
)

export default component.exports